import { useCallback } from "react";
import Web3 from "web3"; // ✅ Use Web3 directly
import { LuckTokenConTract } from "../../utils/contractHelpers";
import { LUCK_TOKEN } from "../../utils/Enviroment";

const BuyBackBurn = () => {
  // ✅ Create Web3 instance directly using RPC (without wallet)
  const web3 = new Web3(
    "https://bnb-mainnet.g.alchemy.com/v2/m1ZDZF0NDLbqkK-we12g0"
  );
  const contractAddress = LUCK_TOKEN;

  const baughtBackhook = useCallback(
    async (helper, addresss) => {
      try {
        const contract = LuckTokenConTract(contractAddress, web3);
        const balance = await contract?.methods?.boughtandburned()?.call();
        const formattedBalance = web3.utils.fromWei(String(balance), "ether");
        return formattedBalance;
      } catch (error) {
        console.error("Error fetching buybackandburn:", error.message || error);
        return "0";
      }
    },
    [web3]
  );

  return {
    baughtBackhook,
  };
};

export default BuyBackBurn;
